export const activeClubMembershipsWithoutThisCreditCard = (
  creditCardId,
  clubMemberships
) => {
  if (!clubMemberships) {
    return [];
  }
  const filteredMemberships = clubMemberships.filter(
    (clubMembership) => clubMembership.customerCreditCardId !== creditCardId
  );
  return filteredMemberships;
};

export const isClubMembershipsWithoutThisCreditCard = (
  creditCardId,
  clubMemberships
) => {
  const memberships = activeClubMembershipsWithoutThisCreditCard(
    creditCardId,
    clubMemberships
  );
  if (memberships.length > 0) {
    return true;
  }
  return false;
};
